"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var dropdown_list_1 = require("@csod/dropdown-list");
var MultiselectDropdown_1 = require("../MultiselectDropdown/MultiselectDropdown");
var CustomFieldDropdown = (function (_super) {
    __extends(CustomFieldDropdown, _super);
    function CustomFieldDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.onSingleSelectChange = _this.onSingleSelectChange.bind(_this);
        _this.onMultiSelectChange = _this.onMultiSelectChange.bind(_this);
        _this.state = {
            items: _this.getItems(props),
        };
        return _this;
    }
    CustomFieldDropdown.prototype.getItems = function (props) {
        var items = [];
        if (!props.isMultiselect) {
            items.push({
                label: props.placeholderText,
                value: '',
                isChecked: false,
            });
        }
        return items.concat(props.items || []);
    };
    CustomFieldDropdown.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ items: this.getItems(nextProps) });
    };
    CustomFieldDropdown.prototype.onSingleSelectChange = function (val) {
        var onChange = this.props.onChange;
        if (onChange) {
            onChange([val]);
        }
        var items = this.state.items;
        items = (items || []).map(function (item) { return Object.assign({}, item, { isChecked: val === item.value }); });
        this.setState({ items: items });
    };
    CustomFieldDropdown.prototype.onMultiSelectChange = function (selectedItems) {
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(selectedItems.map(function (x) { return x.value; }));
        }
    };
    CustomFieldDropdown.prototype.render = function () {
        var _a = this.props, isMultiselect = _a.isMultiselect, placeholderText = _a.placeholderText, buttonTextSuffix = _a.buttonTextSuffix, dropdownHeight = _a.dropdownHeight;
        var items = this.state.items;
        var selectedValue = '';
        if (!isMultiselect && (items || []).length > 1) {
            var item = (items || []).filter(function (x) { return x.isChecked; })[0];
            selectedValue = item ? item.value : '';
        }
        var className = [];
        if (!selectedValue) {
            className.push('placeholder');
        }
        return (React.createElement("div", { className: className.join(' '), "data-tag": this.props.tag },
            !isMultiselect && React.createElement(dropdown_list_1.DropdownList, { items: items, onChange: this.onSingleSelectChange, value: selectedValue }),
            isMultiselect && React.createElement(MultiselectDropdown_1.default, { items: items, placeholder: placeholderText, buttonTextSuffix: buttonTextSuffix, onChange: this.onMultiSelectChange, dropdownHeight: dropdownHeight })));
    };
    return CustomFieldDropdown;
}(React.Component));
CustomFieldDropdown.defaultProps = {
    tag: null,
    isMultiselect: false,
    placeholderText: '',
    buttonTextSuffix: '',
    dropdownHeight: null
};
exports.CustomFieldDropdown = CustomFieldDropdown;
exports.default = CustomFieldDropdown;
//# sourceMappingURL=CustomFieldDropdown.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/build/control/CustomFieldDropdown/CustomFieldDropdown.js
// module id = 271
// module chunks = 0